import { createEntityFilesBlock } from "../entity/createEntityFilesBlock.jsx";
import { sanitizeFileUrl } from "../../utils/filePreview.js";
import { buildWartungInlineFiles } from "../../utils/entityInlineFilePresets.js";

const WARTUNG_TYPEN = ["Plan", "Offerte", "Rechnung", "Bestellung", "Protokoll", "Rapport", "E-Mail", "Foto", "Skizze", "Sonstiges"];

function pickSafeUrl(...candidates) {
  for (const candidate of candidates) {
    const safe = sanitizeFileUrl(candidate || "");
    if (safe) return safe;
  }
  return "";
}

const WartungEntityFilesBlock = createEntityFilesBlock({
  title: "📁 Wartungsdokumente",
  defaultTypes: WARTUNG_TYPEN,
  getApiBase: (vertragId) => (vertragId ? `/wartungsvertraege/${vertragId}` : null),
  getTypeEndpoint: () => "/wartung-dateien/typen",
  resolveFileUrl: (row) => pickSafeUrl(
    row?.secure_preview_url,
    row?.secure_download_url,
    row?.secure_url
  ),
  fileActionMode: "minimal",
  fileActionCompact: true,
  previewModule: "maintenance_contract_files",
});

export default function WartungBlockDateien({ vertragId }) {
  const scrollId = buildWartungInlineFiles(vertragId)?.scrollTargetId;
  return (
    <div id={scrollId || undefined} className={scrollId ? "scroll-mt-24" : undefined}>
      <WartungEntityFilesBlock entityId={vertragId} />
    </div>
  );
}
